import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget, TrimesterDroplistWidget } from '../../../ui/widget';
import { AdmissionsAreaService } from '../admissions-area.service';
import { AdmissionsCommitmentsService } from './admissions-commitments.service';
import { AdmissionsCommitmentsTab1Part } from './tabs/tab-1/admissions-commitments-tab-1.part';
import { AdmissionsCommitmentsTab2Part } from './tabs/tab-2/admissions-commitments-tab-2.part';
import { AdmissionsCommitmentsViewsPart } from './views/commitments-views.part';
@Component({
	selector: 'admissions-commitments-page',
	standalone: true,
	imports: [
		AdmissionsCommitmentsTab1Part, AdmissionsCommitmentsTab2Part, AdmissionsCommitmentsViewsPart,
		PageTab1Directive, PageTab2Directive, PageTab3Directive,
		PageTabsWidget,
		TrimesterDroplistWidget, DroplistWidget, ToolbarWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './admissions-commitments.page.html',
})
export class AdmissionsCommitmentsPage implements OnInit {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Admissions;

	public admissionsService = inject(AdmissionsAreaService);


	constructor(
		public pageService: AdmissionsCommitmentsService,
	) {
	}

	async ngOnInit() {
		await this.admissionsService.loadAdmissionsData();
	}


	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}